export default __webpack_public_path__ + "img/product-row-large.a83e26b4.svg";